import { render, staticRenderFns } from "./NormalSearchNav356.vue?vue&type=template&id=06166456&scoped=true&"
import script from "./NormalSearchNav356.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav356.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06166456",
  null
  
)

export default component.exports